import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

export interface XpColumn {
	field: string;
	header: string;
	active: boolean;
}

@Component({
	selector: 'xp-column-list',
	standalone: true,
	imports: [CommonModule, DragDropModule, MatCheckboxModule, MatIconModule],
	templateUrl: './xp-column-list.component.html',
	styleUrls: ['./xp-column-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpColumnListComponent<T extends XpColumn = XpColumn> {
	columns = model<T[]>([]);

	drop(event: CdkDragDrop<T[]>): void {
		const next = [...this.columns()];
		moveItemInArray(next, event.previousIndex, event.currentIndex);
		this.columns.set(next);
	}

	setActive(column: T, active: boolean): void {
		this.columns.set(this.columns().map(c => (c === column ? { ...c, active } : c)));
	}

	trackByField(_index: number, column: T): string {
		return column.field;
	}
}
